import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Drawer, Spin, Tabs } from 'antd';
import {
  StyledTabs,
  DrawerDesc,
  IDLabel,
  NameLabel,
  DrawerDivider
} from './styled';

const { TabPane } = Tabs;
const DESC = {
  watchLists: 'watchlist(s)',
  whiteLists: 'whitelist(s)',
  watchlist: 'watchlist(s)',
  whitelist: 'whitelist(s)'
};

const SideDrawer = ({
  isOpen,
  onClose,
  visibleItem,
  segment,
  isLoading,
  tabIds,
  errorMessage
}) => {
  const [currentTab, setCurrentTab] = useState('watchLists');

  useEffect(() => {
    setCurrentTab(visibleItem);
  }, [visibleItem]);

  return (
    <Drawer
      // width='25%'
      placement="right"
      visible={isOpen}
      onClose={onClose}>
      <Spin spinning={isLoading}>
        <StyledTabs
          activeKey={currentTab}
          onChange={(activeKey) => setCurrentTab(activeKey)}>
          <TabPane tab="Watchlist" key={tabIds[0]} />
          <TabPane tab="Whitelist" key={tabIds[1]} />
        </StyledTabs>
        <DrawerDesc>
          {`There are ${segment[currentTab]?.length || 'no'} unique ${
            DESC[currentTab]
          } attached to the upload`}
        </DrawerDesc>
        <DrawerDivider />
        {errorMessage && <Alert type="error" message={errorMessage} />}
        {segment[currentTab]?.map((item) => (
          <div key={item.id}>
            <NameLabel>{item.name}</NameLabel>
            <IDLabel>{item.id}</IDLabel>
            <DrawerDivider />
          </div>
        ))}
      </Spin>
    </Drawer>
  );
};

SideDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  visibleItem: PropTypes.string,
  segment: PropTypes.object,
  isLoading: PropTypes.bool,
  tabIds: PropTypes.array,
  errorMessage: PropTypes.string
};

SideDrawer.defaultProps = {
  isLoading: false,
  tabIds: ['watchLists', 'whiteLists']
};

export default SideDrawer;
